module.exports = __webpack_public_path__ + "assets/6b5689e11118e4fbe14132bb8eb2fdf6.png";